import React from "react";
import { connect } from "react-redux";
import { usePreview } from "react-dnd-multi-backend";
import classNames from "classnames";
import "./index.scss";

import { DND_TYPES } from "../../../utils/constants";
import { useStaleDragCleanup } from "../../hooks/useStaleDragCleanup";

import GroupbarOrderItemPreview from "../GroupbarOrderItem/GroupbarOrderItemPreview";

// `usePreview` is taken from react-dnd-multi-backend on purpose: it draws the
// preview only for a backend declared with `preview: true` (the touch one, see
// the DndProvider options in app.js). The react-dnd-preview version renders for
// every backend, so on desktop this component used to paint a second card on
// top of the drag image the browser draws by itself. That copy was pinned to
// `monitor.isDragging()`, which is reset by `dragend` - dispatched only after
// the browser has animated its own image back, and not at all when the dragged
// row is unmounted mid drag (the dashboard re-renders its orders constantly).
// That is what left an order hanging on the screen as if it were still dragged.
const DndPreviewControl = () => {
    const {display, itemType, item, style} = usePreview();
    useStaleDragCleanup();

    if (!display || itemType !== DND_TYPES.group_bar_order || !item) return null;

    return (
        <div className={classNames("dndPreviewControl")} style={{...style, opacity: 1, zIndex: 99999999}}>
            <GroupbarOrderItemPreview key={`dndPreviewControlItem-${item.id}`} order={item} />
        </div>
    );
}

const mapStateToProps = state => ({
    orders: state.order.data.orders || []
});

export default connect(mapStateToProps)(DndPreviewControl);
